<template>
  <div
    class="fts-event"
    :class="[
      stateIndicator ? event.enabled !== false ? 'event--active' : 'event--disabled' : ''
    ]"
    @click="open"
    v-if="event"
  >
    <font-awesome-icon :icon="eventInfo.icon" class="event-icon" v-if="eventInfo.icon" />
    <div class="event-label">
      {{eventInfo.label}}
    </div>
    <div class="event-count" v-if="event.count">
      {{event.count}}
    </div>
  </div>
</template>

<script>
import event from './event';

export default {
  props: {
    event: Object,
    stateIndicator: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    open() {
      this.$emit('open', this.event);
    }
  },
  computed: {
    eventInfo() {
      return event.getEventInfo(this.event);
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin event-state() {
  &::before {
    content: '';
    flex-shrink: 0;
    height: 0.25rem;
    width: 0.25rem;
    margin-left: -0.125rem;
    margin-right: 0.25rem;
    border-radius: 10em;
  }
}
.fts-event {
  min-width: 0;
  display: flex;
  align-items: center;
  padding: 0.125rem 0.375rem;
  border: 1px solid var(--fts-gray-200);
  border-radius: 0.25rem;
  background-color: var(--fts-gray-50);
  color: var(--fts-text);
  font-size: 0.75rem;
  line-height: 1rem;
  cursor: pointer;
  .event-icon {
    margin-right: 0.25rem;
    color: var(--fts-default);
  }
  .event-label {
    word-break: break-all;
  }
  .event-count {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 1rem;
    margin-left: .375rem;
    padding: 0rem .2rem;
    border-radius: .575rem;
    background-color: var(--fts-gray-400);
    color: var(--fts-gray-100);
    font-size: 85%;
  }
  &.event--active {
    @include event-state;
    &::before {
      background-color: var(--fts-success);
    }
  }
  &.event--disabled {
    @include event-state;
    &::before {
      background-color: var(--fts-danger);
    }
  }
  &:hover {
    border-color: rgba(var(--fts-primary-rgb), 0.75);
    background-color: rgba(var(--fts-primary-rgb), 0.085);
    color: var(--fts-primary);
    .event-icon {
      color: inherit;
    }
    .event-count {
      background-color: var(--fts-primary);
      color: #fff;
    }
  }
}
</style>